import { IconType, defaultProps } from './types';

/**
 * Icono Search
 */
export const Search = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="m20 20-3.867-3.867m2.09-5.022a7.111 7.111 0 1 1-14.223 0 7.111 7.111 0 0 1 14.222 0Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
